/*
  FAQ — smooth accordion (Pause Rituals)
  Keeps the accessible native <details>/<summary> (keyboard + screen-reader friendly) but
  animates the open/close HEIGHT with the Web Animations API so it expands and collapses
  smoothly with no sudden jumps. Respects reduced-motion. Re-inits on section load.
*/
(function () {
  var DURATION = 440;
  var EASING = 'cubic-bezier(0.22, 1, 0.36, 1)'; // soft, premium ease-out
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(details) {
    if (details.dataset.faqReady === '1') return;
    details.dataset.faqReady = '1';

    var summary = details.querySelector('.faq__q');
    var content = details.querySelector('.faq__a');
    if (!summary) return;

    var animation = null;
    var isClosing = false;
    var isExpanding = false;

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      // no content (question with no answer) or reduced motion → just toggle instantly
      if (reduce || !content) {
        details.open = !details.open;
        return;
      }
      details.style.overflow = 'hidden';
      if (isClosing || !details.open) {
        openItem();
      } else if (isExpanding || details.open) {
        shrinkItem();
      }
    });

    function openItem() {
      // lock the collapsed height first so opening doesn't flash full-height for a frame
      details.style.height = details.offsetHeight + 'px';
      details.open = true;
      window.requestAnimationFrame(expand);
    }

    function expand() {
      isExpanding = true;
      var startHeight = details.offsetHeight + 'px';
      var endHeight = summary.offsetHeight + content.offsetHeight + 'px';
      if (animation) animation.cancel();
      animation = details.animate({ height: [startHeight, endHeight] }, { duration: DURATION, easing: EASING });
      // gentle content fade-in synced with the reveal
      content.animate({ opacity: [0, 1], transform: ['translateY(-6px)', 'translateY(0)'] }, { duration: DURATION, easing: EASING });
      animation.onfinish = function () { finish(true); };
      animation.oncancel = function () { isExpanding = false; };
    }

    function shrinkItem() {
      isClosing = true;
      details.classList.add('faq__item--closing'); // flips the icon back to "+" during collapse
      var startHeight = details.offsetHeight + 'px';
      var endHeight = summary.offsetHeight + 'px';
      if (animation) animation.cancel();
      animation = details.animate({ height: [startHeight, endHeight] }, { duration: DURATION, easing: EASING });
      animation.onfinish = function () { finish(false); };
      animation.oncancel = function () { isClosing = false; };
    }

    function finish(open) {
      details.open = open;
      animation = null;
      isClosing = false;
      isExpanding = false;
      details.style.height = '';
      details.style.overflow = '';
      details.classList.remove('faq__item--closing');
    }
  }

  function init(root) {
    (root || document).querySelectorAll('.faq__item').forEach(setup);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
